import React, { ComponentType } from 'react'
import { Header } from 'semantic-ui-react'
// Local
import { DISPLAY_MODE, shouldRenderReskin2025 } from '../../../constant'
import * as formatUtils from '../../common/formatUtils'
import NavHeaderButtons from './navHeaderButtons'
import { Encounter } from '../../authenticated/types'
import If from '../../common/if'

const SafeHeader = Header as unknown as ComponentType<any>

/**
 * Provides a vanilla encounter navigation header with links to next and
 * previous encounters and a button to view the encounter as a PDF
 *
 * @param encounter Encounter entity. Required
 * @param links Encounter links to previous and next encounters
 * @param onAction Callback for header button action. Arguments: action
 * @param mode View mode. Options: "SMART", "EMBEDDED", null. Default: null
 */

type Props = {
  encounter: Encounter
  links: any
  onAction?: (action: any) => void | undefined
  mode?: string | undefined | null
}

function NavHeader(
  props: Props
): JSX.Element | null {
  const {
    encounter,
    links,
    onAction,
    mode = 'left'
  } = props

  const onClickHeaderButton = (action: any) => {
    if (onAction) {
      onAction(action)
    }
  }

  if (encounter) {
    return (
      <SafeHeader
        as="h4"
        attached="top"
        block
        className={ `main-schedule-header${shouldRenderReskin2025 ? ' reskin' : '' }` }
        data-testid="nav-header"
      >
        <div className="time">
          { formatUtils.formatEncounterHeaderDate(encounter.start) }
        </div>
        <div className="name">
          { formatUtils.formatPatientNameDob(encounter.patient) }
        </div>
        <If isTrue={ !(mode && mode === DISPLAY_MODE.SMART) }>
          <div className="header-arrows">
            <NavHeaderButtons
              encounter={ encounter }
              links={ links }
              onClick={ onClickHeaderButton }
            />
          </div>
        </If>
      </SafeHeader>
    )
  }
  return null
}

export default NavHeader
